import { cloneDeep } from 'lodash'

import * as actions from './SearchActions'

export default (state = actions.SEARCH_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case actions.SEARCH_FOLLOWS_FETCH: {
      const newState = cloneDeep(state)
      newState.follows = null
      return newState
    }
    case actions.SEARCH_FOLLOWS_FETCH_CANCELED: {
      return state
    }
    case actions.SEARCH_FOLLOWS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.follows = null
      newState.error = action.payload.error
      return newState
    }
    case actions.SEARCH_FOLLOWS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.follows = action.payload.data
      return newState
    }

    case actions.SEARCH_INSTITUTIONS_FETCH: {
      const newState = cloneDeep(state)
      newState.institutions = null
      return newState
    }
    case actions.SEARCH_INSTITUTIONS_FETCH_CANCELED: {
      return state
    }
    case actions.SEARCH_INSTITUTIONS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.institutions = null
      newState.error = action.payload.error
      return newState
    }
    case actions.SEARCH_INSTITUTIONS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.institutions = action.payload.data
      return newState
    }

    case actions.SEARCH_TOURNAMENTS_FETCH: {
      const newState = cloneDeep(state)
      newState.tournaments = null
      return newState
    }
    case actions.SEARCH_TOURNAMENTS_FETCH_CANCELED: {
      return state
    }
    case actions.SEARCH_TOURNAMENTS_FETCH_ERROR: {
      const newState = cloneDeep(state)
      newState.tournaments = null
      newState.error = action.payload.error
      return newState
    }
    case actions.SEARCH_TOURNAMENTS_FETCH_FULFILLED: {
      const newState = cloneDeep(state)
      newState.tournaments = action.payload.data
      return newState
    }

    default:
  }
  return state
}
